module.exports = __webpack_public_path__ + "static/olympic-gold-medalist-education-degree-6c3355309e54f120b4bedb16cc4802da.jpg";